import { Box } from '@mui/material'
import { forwardRef } from 'react'

/**
 * @deprecated remove when animation type changed to video. Please use VideoFullScreen component
 */
export const FullScreenAnimationCell = forwardRef<HTMLCanvasElement>(
  (_, ref) => {
    const ANIMATION_WIDTH = 346
    const ANIMATION_HEIGHT = 614
    const ASPECT_RATIO = ANIMATION_WIDTH / ANIMATION_HEIGHT

    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: '1fr',
          height: '100vh',
          overflow: 'hidden',
          margin: 'auto',
          maxWidth: 600,
          canvas: {
            width: '100%',
            height: '100%',
            zIndex: 1,
            '@media(max-width: 600px)': {
              width: `calc(100vh * ${ASPECT_RATIO})`,
              overflow: 'hidden',
              marginLeft: `calc((100vh * ${ASPECT_RATIO} - 100vw) / 2 * -1)`,
            },
          },
        }}
      >
        <canvas width={ANIMATION_WIDTH} height={ANIMATION_HEIGHT} ref={ref} />
      </Box>
    )
  }
)
